import React from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import { selectorShape } from './Refiner.props';
import { makeStyles } from 'utils';
import classNames from './Refiner.module.css';

const styles = makeStyles(classNames);

function RefinerTextField({
    idBase,
    readOnly,
    selector,
    value,
    onChange
}) {
    return (
        <TextField
            id={idBase + '_value'}
            className={styles('row__input', 'row__form-control')}
            label="Value"
            required
            disabled={readOnly}
            error={!!selector.error}
            helperText={selector.error || null}
            InputProps={{maxLength: 100}}
            value={value || ''}
            onChange={onChange}
        />
    );
}

RefinerTextField.propTypes = {
    idBase: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    selector: PropTypes.shape(selectorShape),
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
};

export default RefinerTextField;